import _ from 'lodash';

export const getBasePath = () => _.trimEnd(`${window.location.protocol}//${window.location.host}`);

export const getParameterByName = (name: string, url?: string) => {
  const testedUrl = url || window.location.href;
  const testedName = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${testedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(testedUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
